export const PERMISSIONS_API_PATH = {
  GET_ALL: "organization-user/permissions/{0}",
};
